import StickerPostback from './StickerPostback';
export default StickerPostback;
